<template>
  <v-container class="general" @scroll="handleScroll">
    <div class="event-content">
      <div
        class="rowStyle"
        v-for="event in eventList"
        :key="event.id"
        @click="goToEventDetails(event)">
        <v-layout wrap align-center>
          <div class="teamLogo" :style="{ backgroundImage: teamLogo }"></div>
          <v-layout
            column
            justify-center
            align-center
            fill-height
            class="event-list-column-type">
            <div class="event-list-type event-list-type-icon-div">
              <img :src="icons[event.eventType.toLowerCase()]" />
            </div>
            <div class="event-list-type">{{ event.eventType }}</div>
          </v-layout>
          <v-layout column class="event-list-column-data">
            <v-layout raw align-center>
              <div class="icon-20px">
                <img :src="icons.eventsCalendar" />
              </div>
              {{ event.date }}
            </v-layout>
            <v-layout raw align-center>
              <div class="icon-20px">
                <img :src="icons.clock" />
              </div>
              {{ event.start }} - {{ event.end }}
            </v-layout>
            <v-layout raw align-center>
              <div class="icon-20px">
                <img :src="icons.location" />
              </div>
              {{ event.location }}
            </v-layout>
          </v-layout>
          <template v-if="event.ended">
            <slot v-if="event.postReport" :name="event.id">
              <div class="small-donut mr-2" style="position: relative">
                <bpChart :chartdata="event.reportChartData"></bpChart>
              </div>
            </slot>
          </template>
          <template v-else>
            <v-layout
              column
              align-center
              justify-center
              class="event-list-column-buttons small-donut">
              <img
                class="postEventSelected"
                :src="
                  require('../../assets/logos/postEventSelectedIcon.png')
                    .default
                " />
              <img
                v-if="event.postReport"
                class="bgDone"
                :src="icons.greenCheck" />
            </v-layout>
          </template>
        </v-layout>
      </div>
    </div>
    <v-layout class="footer event-footer">
      <v-select
        outlined
        dark
        color="success"
        class="select-events-filter"
        :items="eventTypes"
        item-text="name"
        item-value="value"
        v-model="filters.eventType"
        append-icon="fas fa-arrow-circle-up"></v-select>

      <v-select
        outlined
        dark
        color="success"
        class="select-events-filter"
        :items="seasons"
        item-text="name"
        item-value="value"
        v-model="filters.season"
        append-icon="fas fa-arrow-circle-up"></v-select>
    </v-layout>
    <v-dialog
      v-model="bpConnectionDialog"
      max-width="350"
      class="dialog-window">
      <v-card>
        <v-card-text>
          Would you like to link your beyond pulse stats?
        </v-card-text>
        <v-card-actions>
          <v-btn color="green darken-1" text @click="bpConnect(false)">
            No
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="bpConnect(true)">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import constants from "@/constants.js"
import moment from "moment"
import firebaseApi from "@/api/firebase.api.js"
import { apiWrapper } from "@/lib/utils"
import bpChart from "./event/detail/strips/bpChart.vue"
import { mapState } from "vuex"

export default {
  name: "Events",
  components: { bpChart },
  data() {
    return {
      time: null,
      interval: null,
      events: [],
      eventList: [],
      upcommingEventList: [],
      userProfile: this.$store.state.user.profile,
      pastEventList: [],
      loadingData: false,
      noMoreEvents: false,
      bpConnectionDialog: false,
      eventListTab: this.$store.getters.getCurrentEventsListTab,
      lastLoadedEvent: null,
      icons: constants.icons,
      sort: "asc",
      period: "",
      limit: 20,
      generalFilterList: [],
      filtersEnable: false,
      bpChartOptions: {
        cutoutPercentage: 80,
        tooltips: { enabled: false },
        hover: { mode: null },
        draw: function (a) {
          console.log(a)
        },
      },
      filters: {
        eventType: "",
        season: {},
      },
      seasons: [],
      origSeasons: [
        {
          name: "Season",
          value: { dateFrom: 0, dateTo: 0 },
        },
      ],
      eventTypes: [
        {
          name: "Event Type",
          value: "",
        },
        {
          name: "Training",
          value: "Training",
          icon: constants.icons.training,
        },
        {
          name: "Game",
          value: "Game",
          icon: constants.icons.game,
        },
        {
          name: "Strength",
          value: "Strength",
          icon: constants.icons.strength,
        },
        {
          name: "Recovery",
          value: "Recovery",
          icon: constants.icons.recovery,
        },
        {
          name: "Meeting",
          value: "Meeting",
          icon: constants.icons.meeting,
        },
      ],
    }
  },
  computed: {
    team() {
      return this.$store.getters["teamList/activeTeam"] || {}
    },
    teamLogo() {
      const url = this.team?.imgUrl
        ? this.team.imgUrl
        : require("@/assets/icons/team_img.png").default
      return `url(${url})`
    },
    newEvents() {
      return this.$store.state.newEvents
    },
    eventTypeFilter() {
      return this.filters.eventType
    },
    seasonFilter() {
      return this.filters.season
    },
    ...mapState("user", {
      awaitedUser: (state) => {
        return state.profile
      },
      bpAuth: (state) => state.bpAuth === "logged in",
    }),
  },
  methods: {
    awaitUserProfileOnReload() {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          const userData = this.awaitedUser || {}
          if (Object.keys(userData).length) {
            clearInterval(interval)
            resolve(userData)
          }
        }, 1000)
      })
    },
    config() {
      this.seasons = JSON.parse(JSON.stringify(this.origSeasons))
      this.period = this.eventListTab
      this.filters.eventType = this.eventTypes[0].value
      this.filters.season = this.origSeasons[0].value

      if (this.period === "upcoming") {
        this.generateUpcommingSeasons()
        this.sort = "asc"

        this.generalFilterList = [
          {
            where: "dateAsNumber",
            op: ">",
            value: moment(new Date()).unix(),
          },
        ]
      } else {
        this.generatePastSeasons()
        this.sort = "desc"

        this.generalFilterList = [
          {
            where: "dateAsNumber",
            op: "<",
            value: moment(new Date()).unix(),
          },
        ]
      }
    },
    init(options = {}) {
      this.loadingData = true
      this.$store.commit("setOverlay", true)
      const filterList = [].concat(this.generalFilterList)
      if (options.filters) {
        if (options.filters.eventType) {
          filterList.push({
            where: "eventType",
            op: "==",
            value: options.filters.eventType,
          })
        }
        if (
          options.filters.season &&
          options.filters.season.dateFrom &&
          options.filters.season.dateTo
        ) {
          filterList.push({
            where: "dateAsNumber",
            op: ">=",
            value: options.filters.season.dateFrom,
          })
          filterList.push({
            where: "dateAsNumber",
            op: "<=",
            value: options.filters.season.dateTo,
          })
        }
      }

      const params = {
        filters: filterList,
        sort: this.sort,
        limit: this.limit,
        lastLoadedEvent: options.next ? this.lastLoadedEvent : null,
      }
      this.$store
        .dispatch("getEventsListV2", params)
        .then(async (data) => {
          const { userEvents, teamEvents, lastTeamEvent } = data
          this.lastLoadedEvent = lastTeamEvent
          this.noMoreEvents = !this.lastLoadedEvent
          let events = userEvents.concat(teamEvents)

          if (options.next) {
            events = events.filter(Boolean)

            const formatedEvnts = events.map((e) => this.formatList(e))

            for (let i = 0; i < formatedEvnts.length; i++) {
              const evnt = formatedEvnts[i]
              const eventEnded = this.$moment(
                evnt.date + " " + evnt.end,
                "dddd, MMMM Do YYYY h:mm a"
              ).isBefore()
              if (eventEnded && evnt.postReport) {
                const { eventReport, eventReportChartData, individualScores } =
                  await this.getEventReport(evnt.id)
                formatedEvnts[i].ended = eventEnded
                formatedEvnts[i].report = eventReport
                formatedEvnts[i].reportChartData = eventReportChartData
                formatedEvnts[i].individualScores = individualScores
              }
            }

            this.eventList = this.eventList.concat(formatedEvnts)
          } else {
            events = events.filter(Boolean)
            const formatedEvnts = events.map((e) => this.formatList(e))

            for (let i = 0; i < formatedEvnts.length; i++) {
              const evnt = formatedEvnts[i]

              const eventEnded = this.$moment(
                evnt.date + " " + evnt.end,
                "dddd, MMMM Do YYYY h:mm a"
              ).isBefore()
              if (eventEnded && evnt.postReport) {
                const { eventReport, eventReportChartData, individualScores } =
                  await this.getEventReport(evnt.id)
                formatedEvnts[i].ended = eventEnded
                formatedEvnts[i].report = eventReport
                formatedEvnts[i].reportChartData = eventReportChartData
                formatedEvnts[i].individualScores = individualScores
              }
            }
            this.eventList = formatedEvnts
          }

          //* sorting events chronologically
          this.eventList = (() => {
            const uniqueIdSet = new Set(this.eventList.map((elem) => elem.id))
            const res = []
            uniqueIdSet.forEach((id) => {
              const uniqueEvent = this.eventList.find(
                (event) => event.id === id
              )
              res.push(uniqueEvent)
            })
            //* ascending
            if (this.sort === "asc") {
              res.sort((a, b) => {
                return (
                  parseInt(a.dateAsNumber, 10) - parseInt(b.dateAsNumber, 10)
                )
              })
            }
            //* descending = reverse chronological
            if (this.sort === "desc") {
              res.sort(
                (a, b) =>
                  parseInt(b.dateAsNumber, 10) - parseInt(a.dateAsNumber, 10)
              )
            }
            return res
          })()

          this.$store.commit("setOverlay", false)
          this.$store.commit("setField", { key: "newEvents", value: false })

          this.filtersEnable = true
          this.loadingData = false
        })
        .catch((e) => console.error(e))
    },

    async getEventReport(eventId) {
      let eventReport = await firebaseApi.getEventRPEs(eventId)
      let individualScores
      if (typeof eventReport === "object") {
        individualScores = eventReport.individualScores
        eventReport = eventReport.overall
      }
      let color = ""

      if (eventReport > 0 && eventReport <= 3) {
        color = "#02c905"
      } else if (eventReport > 3 && eventReport <= 6) {
        color = "#eded02"
      } else if (eventReport > 6 && eventReport <= 8) {
        color = "#ff9800"
      } else if (eventReport > 8) {
        color = "#ed0202"
      }

      const eventReportChartData = {
        data: eventReport,
        color: { color },
        meta: { showPercent: false, scale: 10, precision: 1 },
      }
      return { eventReport, eventReportChartData, individualScores }
    },

    async bpConnect(flag) {
      this.$store.commit("user/setProfile", {
        ...this.$store.state.user.profile,
        bpConnectionAsked: 1,
      })
      this.$store.commit("activateProgressBar", true)
      await apiWrapper(firebaseApi.setBPconnectAsked)
      this.bpConnectionDialog = false
      this.$store.commit("activateProgressBar", false)
      if (flag) {
        this.$router.push({ name: "BeyondPulseConnect" })
      }
    },
    // format event list
    formatList(event) {
      if (!event) {
        return
      }
      let date = new Date(event.dateAsNumber * 1000)
      date = this.$moment(date).second(0)
      const formattedEvent = {}
      formattedEvent.id = event.id
      formattedEvent.date = date.format("dddd, MMMM Do YYYY")
      formattedEvent.start = date.format("h:mm a")
      formattedEvent.end = date.add(event.duration, "m").format("h:mm a")
      formattedEvent.eventType = event.eventType
      formattedEvent.location = event.location
      formattedEvent.postReport = event.postReport === "Yes"
      formattedEvent.dateAsNumber = event.dateAsNumber
      formattedEvent.attendees = event.attendees || {}
      formattedEvent.absentees = event.absentees || {}
      formattedEvent.biometricData = event.biometricData || {}
      formattedEvent.duration = event.duration
      formattedEvent.notes = event.notes
      return formattedEvent
    },
    goToEventDetails(event) {
      this.$router.push({
        name: "EventDetail",
        params: { ...event },
      })
    },
    generateUpcommingSeasons() {
      const now = new Date()
      for (let i = 0; i < 12; i++) {
        const m = moment(now).add(i, "M")
        const monthNumber = m.month()
        const monthString = moment(monthNumber + 1, "M").format("MMMM")
        const monthStartUnix = moment(m).startOf("month").unix()
        const monthEndUnix = moment(m).endOf("month").unix()

        this.seasons.push({
          name: monthString,
          value: {
            dateFrom: monthStartUnix,
            dateTo: monthEndUnix,
          },
        })
      }
    },
    generatePastSeasons() {
      const now = new Date()
      for (let i = 0; i < 4; i++) {
        const q = moment(now).subtract(i, "Q")
        const quarterStartUnix = moment(q).startOf("quarter").unix()
        const quarterEndUnix = moment(q).endOf("quarter").unix()

        const quarterString = `Q${q.quarter()} ${q.year()}`

        this.seasons.push({
          name: quarterString,
          value: {
            dateFrom: quarterStartUnix,
            dateTo: quarterEndUnix,
          },
        })
      }
    },
    handleScroll(e) {
      if (!this.loadingData && !this.noMoreEvents) {
        // SCROLL CALC
        const s = e.currentTarget.scrollTop
        const ch = e.currentTarget.clientHeight
        const sh = e.currentTarget.scrollHeight

        // get sp (scroll position) inside the target
        const sp = s + ch

        // if sp reached sh (scroll height) then load other data
        if (sp === sh) {
          this.init({
            filters: this.filters,
            next: true,
          })
        }
      }
    },
  },
  async mounted() {
    const userProfile =
      this.userProfile || (await this.awaitUserProfileOnReload())
    this.bpConnectionDialog = !!(
      userProfile.coachOrPlayer === "Player" &&
      !this.bpAuth &&
      !userProfile.bpConnectionAsked
    )
    if (!this.bpConnectionDialog) {
      this.config()

      this.init()
    }
  },

  watch: {
    newEvents(value) {
      if (value) {
        this.init({
          filterList: [
            {
              where: "dateAsNumber",
              op: ">",
              value: moment(new Date()).unix(),
            },
          ],
        })
      }
    },
    "$store.getters.getCurrentEventsListTab": function (newVal, oldVal) {
      this.seasons = JSON.parse(JSON.stringify(this.origSeasons))

      this.filters.eventType = this.eventTypes[0].value
      this.filters.season = this.origSeasons[0].value

      this.noMoreEvents = false

      if (newVal === "upcoming") {
        this.generateUpcommingSeasons()
        this.sort = "asc"
        this.period = "upcomming"

        this.generalFilterList = [
          {
            where: "dateAsNumber",
            op: ">",
            value: moment(new Date()).unix(),
          },
        ]
      } else {
        this.generatePastSeasons()
        this.sort = "desc"
        this.period = "past"
        this.generalFilterList = [
          {
            where: "dateAsNumber",
            op: "<",
            value: moment(new Date()).unix(),
          },
        ]
      }
      this.init()
    },
    eventTypeFilter(newVal) {
      if (this.filtersEnable) {
        this.init({
          filters: this.filters,
        })
      }
    },
    seasonFilter(newVal) {
      if (this.filtersEnable) {
        this.init({
          filters: this.filters,
        })
      }
    },
    bpConnectionDialog(newVal) {
      if (!newVal) {
        this.config()
        this.init()
      }
    },
  },
  // ! ================== this code creates a realtime localized clock; =================================
  // ! ================== filters upcoming vs past events every minute ==================================
  // beforeDestroy() {
  //   clearInterval(this.interval)
  // },
  // created() {
  //   const newMinuteCheck = setInterval(() => {
  //     const newMinute = !(new Date().getSeconds() % 60)
  //     if (newMinute) {
  //       //* run the update the first time it's a new minute...
  //       // console.log(
  //       //   "even minute",
  //       //   Intl.DateTimeFormat(navigator.language, {
  //       //     hour: "numeric",
  //       //     minute: "numeric",
  //       //     second: "numeric",
  //       //   }).format()
  //       // )
  //       this.init({
  //         filterList: [
  //           {
  //             where: "dateAsNumber",
  //             op: ">",
  //             value: moment(new Date()).unix(),
  //           },
  //         ],
  //       })
  //       //* ... and then every minute after that
  //       this.interval = setInterval(() => {
  //         // console.log(
  //         //   "then every next minute",
  //         //   Intl.DateTimeFormat(navigator.language, {
  //         //     hour: "numeric",
  //         //     minute: "numeric",
  //         //     second: "numeric",
  //         //   }).format()
  //         // )
  //         this.init({
  //           filterList: [
  //             {
  //               where: "dateAsNumber",
  //               op: ">",
  //               value: moment(new Date()).unix(),
  //             },
  //           ],
  //         })
  //         //* if we want to include clock👇 use that code
  //         // Concise way to format time according to system locale.
  //         // In my case this returns "3:48:00 am"
  //         // this.time = Intl.DateTimeFormat(navigator.language, {
  //         //   hour: "numeric",
  //         //   minute: "numeric",
  //         //   second: "numeric",
  //         // }).format();
  //       }, 60000)
  //       //* clears the every-second poll of real-time
  //       clearInterval(newMinuteCheck)
  //     }
  //     // console.log("every second polling")
  //   }, 1000)
  // },
  // ! ================================== end ==================================
}
</script>

<style scoped lang="sass">
@import '@/assets/sass/globals.sass'

.small-donut
  max-height: 120px
  max-width: 120px

// .event-content

.event-footer
  position: fixed
  bottom: 0
  left: 0
  // display: flex
  justify-content: space-around
  .v-input
    flex: initial
    & ::v-deep .v-select__selection--comma
      width: 100%
      text-align: center
      // border: 5px solid red !important
    & ::v-deep .v-select__slot
      width: 95%
      // .v-input__slot
      //     .theme--dark.v-select .v-select__selections
      //       .v-select__selection
      //         .v-select__selection--comma

.rowStyle
  padding: 20px 0px
  border-bottom: 1px solid transparentize($white, 0.4)

  &:hover
    cursor: pointer

.event-list-column-type
  max-width: 80px
  margin: auto 20px auto auto
// TODO investigate why '& *' This selector doesn't have any properties and won't be rendered.
  // & *
  // text-align: center

.event-list-column-data
  min-width: 350px
  margin: 15px auto

.event-list-column-buttons
  max-width: 80px
  margin: auto
// TODO investigate why '& *' This selector doesn't have any properties and won't be rendered.
  // & *
  //   text-align: center

.icon-20px
  height: 20px
  width: 20px
  margin-right: 10px

  img
    margin: auto
    display: block

.general
  font-size: 1.3em
  color: $white
  margin: 0px !important
  width: 100%
  max-width: unset !important
  max-height: calc(100vh - 125px)
  overflow: auto
  margin-top: 4px !important

.teamLogo
  height: 60px
  width: 60px
  margin-right: 20px
  background-position: center
  background-size: cover
  border-radius: 100%
  overflow: hidden

.postEventSelected, .bgDone
  max-height: 50px
  height: 50px
  margin: 0 auto 1rem auto

  &:first-child
    position: relative
    left: 2.5px
.footer
  width: 100%
  background-color: #1F244D
  border: 1px solid $border-header-footer
  height: 70px
  padding: 0

.common
  height: 30px
  width: 30px
  background-size: contain
  background-repeat: no-repeat
  margin-top: 8%
  cursor: pointer
</style>
